<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  .progress-bar {
    height: utils.in_rem(6px);
    min-height: utils.in_rem(6px);
    background: colors.get(interfaceSwGrey_10);
    border-radius: utils.in_rem(3px);
    overflow: hidden;

    &.external {
      background: colors.get(interfaceWhite);
    }

    .progress-fill {
      height: 100%;
      transition: width 0.3s ease-in-out;
      border-radius: utils.in_rem(3px);
      &.low {
        background: colors.get(chartGood);
      }
      &.medium {
        background: colors.get(chartNearingAttention);
      }
      &.full {
        background: colors.get(chartNeedsAttention);
      }
    }
  }
</style>

<script>
  let { activeCount, total, type } = $props();

  let width = $derived.by(() =>
    total <= 0 ? 0 : Math.min(100, Math.round((activeCount / total) * 100))
  );

  let colorCls = $derived.by(() => {
    if (75 <= width && width < 100) return "medium";
    return width === 100 ? "full" : "low";
  });
</script>

<div class="progress-bar {type}">
  <div class="progress-fill {colorCls}" style="width: {width}%"></div>
</div>
